import request from '@/utils/request';
export function simpleWeatherApi(params) {
  return request({
    url: '/util/weather/simpleWeather',
    method: 'get',
    params: params
  });
}